import { type FC, type ReactNode, useState } from "react";
import { Box, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useTranslation } from "react-i18next";
import { isVideoFile } from "./isVideoFile";

interface UploadsZoneProps {
  onFiles: (files: File[]) => void;
  children: ReactNode;
}

/**
 * Клон референсного UploadsZone (Rightholder/Videos/UploadsZone/UploadsZone.js):
 * оверлей ПОДМЕНЯЕТ children целиком (а не рисуется поверх них), занимает
 * весь остаток вьюпорта под шапкой и без пунктирной рамки.
 */
export const UploadsZone: FC<UploadsZoneProps> = ({ onFiles, children }) => {
  const { t } = useTranslation();
  const [dragOver, setDragOver] = useState(false);

  return (
    <Box
      sx={{ position: "relative", minHeight: "calc(100vh - 64px)" }}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        const files = Array.from(e.dataTransfer.files).filter(isVideoFile);
        if (files.length) onFiles(files);
      }}
    >
      {dragOver ? (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            bgcolor: "#1f1f1fdb",
            pointerEvents: "none",
          }}
        >
          <CloudUploadIcon fontSize="large" />
          <Typography variant="h5">
            {t("videos.uploadsZone.dropHint")}
          </Typography>
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};
